// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Numeral = require("../../../utils/Numeral.bs.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");

function formatValue(value) {
  if (value % 1.0 === 0.0) {
    return Numeral.formatNumber(value | 0);
  } else {
    return Numeral.formatFloat(value);
  }
}

function formatInputString(inputValue, unit) {
  if (unit === "ACRE") {
    return Form__Helpers.formatDecimalInputString(inputValue);
  } else {
    return Form__Helpers.formatIntInputString(inputValue);
  }
}

function truncateToSqFt(value) {
  return Stdlib_Option.map(value, value => value | 0);
}

function suffixFromUnit(unit) {
  if (unit === "ACRE") {
    return "AcreLot";
  } else {
    return "SqftLot";
  }
}

exports.formatValue = formatValue;
exports.formatInputString = formatInputString;
exports.truncateToSqFt = truncateToSqFt;
exports.suffixFromUnit = suffixFromUnit;
/* Numeral Not a pure module */
